"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _auth = require("@modules/auth");

var _state = _interopRequireDefault(require("./state"));

var _actions = require("./actions");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys = Object.keys(source);

    if (typeof Object.getOwnPropertySymbols === 'function') {
      ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }

    ownKeys.forEach(function (key) {
      _defineProperty(target, key, source[key]);
    });
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var _default = function _default() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _state.default;
  var action = arguments.length > 1 ? arguments[1] : undefined;

  switch (action.type) {
    case _actions.FETCH_PRODUCT_SUCCESS:
      return _objectSpread({}, state, {
        active: action.product.active,
        badges: action.product.badges,
        brand: action.product.brand,
        contents: action.product.contents,
        description: action.product.description,
        id: action.product.id,
        isPromo: action.product.isPromo,
        images: action.product.images,
        manufacturer: action.product.manufacturer,
        measurementUnit: action.product.measurementUnit,
        medias: action.product.medias,
        name: action.product.name,
        oldPrice: action.product.oldPrice,
        price: action.product.price,
        priceMeasurementUnit: action.product.priceMeasurementUnit,
        priceUnit: action.product.priceUnit,
        promo: action.product.promo,
        slug: action.product.slug,
        tags: action.product.tags,
        unitQuantity: action.product.unitQuantity
      });

    case _actions.FETCH_RELATED_PRODUCTS_SUCCESS:
      return _objectSpread({}, state, {
        relatedProducts: action.products
      });

    case _auth.authActions.PURGE_ALL:
      return _state.default;

    default:
      return state;
  }
};

exports.default = _default;